module.exports = __webpack_public_path__ + "static/media/img_nextbtn.ab534a1a.svg";